import { PlaceholderPage } from './PlaceholderPage';

export const FormulasPage = () => <PlaceholderPage title="Formulas" />;
